<script>
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Header extends Vue {
  render() {
    return <header class="header">{this.$slots.default}</header>
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Header.vue